import { teachersConstants } from './constants';

var viewActions = require ('../../store/view.actions');
var teachersService = require ('./api');

export const teachersActions = {
  getTeacherCourses ,
  getCourseSubject,
  getCourseSubjectStudents,
  getCourseEvals,
  getCourseSubjectStudentsEvals,
  updateCourseSubjectStudentsEvals,
  deleteCourseSubjectStudentsEvals,
  addCourseSubjectStudentsEvals,
  getAllEvals
};  

function  updateCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, data, qualifValue) {

  return dispatch => {
          dispatch(viewActions.isLoadingModule('savingEvaluation',true)) ;

          teachersService.updateCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, data )
          .then( json => {
                  dispatch( { 
                    type: teachersConstants.UPD_COURSE_STUDENT_EVALS,
                    evaluation_id: evaluationID,
                    qualifValue: qualifValue,
                    data: data,
                    persona_id: personaID 
                    
                  }) ;
                dispatch(viewActions.isLoadingModule('savingEvaluation',false));
            } )
  }
}


function  addCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, qualifValue, qualifValueNbr, comments ) {
  return dispatch => {
          dispatch(viewActions.isLoadingModule('savingEvaluation',true)) ;
          teachersService.addCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, 
                                                            qualifValue.qualif_value_id, qualifValueNbr, comments )
          .then( json => {
                  dispatch( { 
                    type: teachersConstants.ADD_COURSE_STUDENT_EVALS,
                    evaluation_id: evaluationID,
                    qualifValue: qualifValue,
                    qualifValueNbr: qualifValueNbr,
                    comments: comments,
                    persona_id: personaID
                  }) ;
                dispatch(viewActions.isLoadingModule('savingEvaluation',false));
            } )
  }
}

function  deleteCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID ) {

  return dispatch => {
          dispatch(viewActions.isLoadingModule('savingEvaluation',true)) ;
          teachersService.deleteCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID )
          .then( json => {
                  dispatch( { 
                    type: teachersConstants.DEL_COURSE_STUDENT_EVALS,
                    persona_id: personaID,
                    evaluation_id: evaluationID
                  }) ;
                  dispatch(viewActions.isLoadingModule('savingEvaluation',false));
            } )
}
}

function getTeacherCourses( token, personaID , calendarID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getTeacherCourses', true)) ;
       
          teachersService.getTeacherCourses( token, personaID , calendarID )
          .then( json => {
              dispatch( { 
                        type: teachersConstants.SHOW_TEACHER_COURSES,
                        teacherCourses: json
                      }) ;
              dispatch(viewActions.isLoadingModule('getTeacherCourses', false) )
          } )
          
  }
}

function getCourseSubjectStudentsEvals( token, courseSubjectID, personaID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getCourseSubjectStudentsEvals', true)) ;
          teachersService.getCourseSubjectStudentsEvals( token, courseSubjectID, personaID )
          .then( json => {
              dispatch( { 
                        type: teachersConstants.SHOW_COURSE_STUDENT_EVALS,
                        courseStudentEvals: json
                      }) ;
              dispatch(viewActions.isLoadingModule('getCourseSubjectStudentsEvals', false)) ;
          } )
          
  }
}
function getCourseEvals( token, courseSubjectID ) { 
  return dispatch => {
       
          teachersService.getCourseEvals( token, courseSubjectID )
          .then( json => {
              dispatch( { 
                        type: teachersConstants.SHOW_COURSE_EVALS,
                        courseEvals: json
                      }) ;
          } )
          
  }
}

function getAllEvals( token, courseSubjectID ) { 
  return dispatch => {
       
          teachersService.getAllEvals( token, courseSubjectID )
          .then( json => {
              dispatch( { 
                        type: teachersConstants.SHOW_ALL_EVALS,
                        allEvals: json
                      }) ;
          } )
          
  }
}


function getCourseSubject( token, courseSubjectID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getCourseSubject', true)) ;
       
          teachersService.getCourseSubject( token, courseSubjectID )
          .then( json => {
              dispatch( { 
                        type: teachersConstants.SHOW_COURSE_SUBJECT,
                        courseSubject: json
                      }) ;
              dispatch(viewActions.isLoadingModule('getCourseSubject', false) )
          } )
          
  }
}

function getCourseSubjectStudents( token, courseSubjectID ) { 
  return dispatch => {
          dispatch(viewActions.isLoadingModule('getCourseSubjectStudents', true)) ;
       
          teachersService.getCourseSubjectStudents( token, courseSubjectID )
          .then( json => {
              dispatch( { 
                        type: teachersConstants.SHOW_COURSE_STUDENTS,
                        courseStudents: json
                      }) ;
              dispatch(viewActions.isLoadingModule('getCourseSubjectStudents', false) )
          } )
          
  }
}

